













































































































































































































































































































































































import {
  defineComponent,
  computed,
  ref,
  onMounted,
  onBeforeUnmount,
  useRouter
} from '@nuxtjs/composition-api'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
import { ciFolderOpen } from '~/icons/source/regular/folder-open'
import {
  faPlusSquare,
  faHeart,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import ScrollService from '~/services/scroll/ScrollService'
import { useDep } from '~/compositions/dependency-container'
import { ciPaperPlane } from '~/icons/source/solid/paper-plane'
import {
  UserAgentState,
  USER_AGENT_NS
} from '~/store/modules/shared/userAgent/state'
import { useNamespacedStore } from '~/compositions/store'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import HeadService from '~/services/HeadService'
import { useApp } from '~/compositions/app'
import { capitalizeString } from '~/utils/string'

export default defineComponent({
  components: { CDragScroll, CCollapse, PlusMinusCollapseOpener },
  setup() {
    const scrollService = useDep(ScrollService)
    const pg2Ref = ref(null)
    const mouseDown = ref(false)
    const startX = ref(null)
    const scrollLeft = ref(null)
    const firstStepper = ref(null)
    const steppersRef = ref(null)
    const firstStepperWidth = ref(null)
    const secondStepperWidth = ref(null)
    const icons = computed(() => ({
      times: faTimes,
      heart: faHeart,
      chevronDown: ciAngleDownLight,
      ciFolderOpen,
      plusSquare: faPlusSquare,
      paperPlane: ciPaperPlane
    }))
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const router = useRouter()

    const isMobile = computed(() => userAgentGetters('isMobile'))
    const { isCar, isPlot } = useApp()

    const { getters } = useNamespacedStore<UserState>(USER_NS)
    const userIsSingleOrAnon = computed(() => getters('isSingleOrAnon'))

    const myClassifiedLink = computed(() => {
      if (userIsSingleOrAnon.value) {
        return '/login/'
      } else {
        return '/classifieds/my/'
      }
    })
    const newClassifiedLink = computed(() => {
      if (userIsSingleOrAnon.value) {
        return '/login/'
      } else {
        return '/classifieds/new/?type=new'
      }
    })

    onMounted(() => {
      window.addEventListener('resize', onWindowResize)
      setSteppersWidth()
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', onWindowResize)
    })

    const setSteppersWidth = () => {
      firstStepperWidth.value = steppersRef.value[0].scrollWidth - 32
      secondStepperWidth.value = steppersRef.value[1].scrollWidth - 32
    }

    const startDragging = (e, index: number) => {
      mouseDown.value = true
      startX.value = e.pageX - steppersRef.value[index].offsetLeft
      scrollLeft.value = steppersRef.value[index].scrollLeft
    }

    const stopDragging = () => {
      mouseDown.value = false
    }

    const mousemove = (e, index: number) => {
      e.preventDefault()
      if (!mouseDown.value || !isMobile) {
        return
      }
      const x = e.pageX - steppersRef.value[index].offsetLeft
      const scroll = x - startX.value
      steppersRef.value[index].scrollLeft = scrollLeft.value - scroll
    }

    const tradesUrl = computed(() => router.resolve({ name: '__trades' }).href)
    const tradesSiteName = computed(() => (isCar.value ? 'car.gr' : 'plot.gr'))

    const firstStepperData = computed(() => [
      {
        img: isPlot.value
          ? '/nuxt-static/img/trades/plot/trades-step-a1.png'
          : '/nuxt-static/img/trades/trades-step-a1.png',
        text: 'Κάνε σύνδεση ή εγγραφή σαν χρήστης'
      },
      {
        img: isPlot.value
          ? '/nuxt-static/img/trades/plot/trades-step-a2.png'
          : '/nuxt-static/img/trades/trades-step-a2.png',
        text: 'Καταχώρισε μια νέα αγγελία'
      },
      {
        img: '/nuxt-static/img/trades/trades-step-ab3.png',
        text: 'Ενεργοποίησε την επιλογή των ανταλλαγών'
      },
      {
        img: isPlot.value
          ? '/nuxt-static/img/trades/plot/trades-step-ab4.png'
          : '/nuxt-static/img/trades/trades-step-ab4.png',
        text: 'Διάλεξε τις κατηγορίες με τις οποίες την ανταλλάζεις'
      }
    ])

    const secondStepperData = computed(() => [
      {
        img: `/nuxt-static/img/trades/${
          isPlot.value ? 'plot/' : ''
        }trades-step-b1.png`,
        text:
          'Συνδέσου στο λογαριασμό σου και πάτησε στο κουμπί "Επεξεργασία" της αγγελίας'
      },
      {
        img: `/nuxt-static/img/trades/${
          isPlot.value ? 'plot/' : ''
        }trades-step-b2.png`,
        text: 'Επίλεξε την καρτέλα "στοιχεία"'
      },
      {
        img: '/nuxt-static/img/trades/trades-step-ab3.png',
        text: 'Ενεργοποίησε την επιλογή των ανταλλαγών'
      },
      {
        img: isPlot.value
          ? '/nuxt-static/img/trades/plot/trades-step-ab4.png'
          : '/nuxt-static/img/trades/trades-step-ab4.png',
        text: 'Διάλεξε τις κατηγορίες με τις οποίες την ανταλλάζεις'
      }
    ])

    const faqs = computed(() => {
      const faqsArray = [
        {
          q: `Τι είναι οι ανταλλαγές του ${capitalizeString(
            tradesSiteName.value
          )};`,
          a: `Είναι ο έξυπνος τρόπος για να ανταλλάξεις το ${
            isCar.value ? 'αυτοκίνητο' : 'ακίνητο'
          } σου με ένα άλλο. Να ανταλλάξεις το ${
            isCar.value
              ? 'αυτοκίνητο σου με μια μοτοσυκλέτα'
              : 'διαμέρισμά σου με ένα οικόπεδο'
          }. Να ανταλλάξεις ${
            isCar.value
              ? 'ένα κινητό τηλέφωνο με μια μοτοσυκλέτα'
              : 'την αποθήκη σου με μία μεζονέτα'
          } ή ότι άλλο μπορείς να φανταστείς.`
        },

        {
          q: 'Που βρίσκω τις ανταλλαγές;',
          a: `Τις ανταλλαγές θα τις βρεις στο <a target="_blank" href="${tradesUrl.value}">${tradesSiteName.value}${tradesUrl.value}</a>`
        },

        {
          q: 'Πως μπορώ να ξεκινήσω να ανταλλάζω;',
          a: `Για αρχή θα χρειαστείς να έχεις λογαριασμό και μια ενεργή αγγελία στο ${capitalizeString(
            tradesSiteName.value
          )}. Κατόπιν θα χρειαστεί να ενεργοποιήσεις τη σχετική λειτουργία ανταλλαγών στα στοιχεία της αγγελίας. Εάν δε διαθέτεις κάποια αγγελία αγγελία τότε θα χρειαστεί να προσθέσεις μια καινούρια και να ενεργοποιήσεις τη σχετική λειτουργία "ανταλλαγές".`
        },

        {
          q: 'Πως επιλέγω με ποια κατηγορία θέλω να ανταλλάξω την αγγελία μου;',
          a: `Αφού ενεργοποιήσεις τη σχετική λειτουργία σε μια αγγελία, κατόπιν θα μπορέσεις από το δέντρο των κατηγορίων του ${capitalizeString(
            tradesSiteName.value
          )} να επιλέξεις την κατηγορία ή τις κατηγορίες με τις οποίες θα σε ενδιέφερε η ανταλλαγή.`
        },
        {
          q:
            'Πως θα βρω τις άλλες αγγελίες με τις οποίες θα μπορούσα να ανταλλάξω;',
          a: `Πηγαίνοντας στο <a target="_blank" href="${tradesUrl.value}">${tradesSiteName.value}${tradesUrl.value}</a> σου δείχνει τις αγγελίες που έχεις διαθέσιμες προς ανταλλαγή και επιλέγοντας την αγγελία που σε ενδιαφέρει, μεταφέρεσαι στη πλατφόρμα ανταλλαγών. Εδώ ή διαδικασία είναι ιδιαίτερα απλή, σέρνεις τη φωτογραφία προς τα αριστερά εάν κάτι δεν σου αρέσει ή προς τα δεξιά εάν κάτι σου αρέσει. Σε κάθε περίπτωση μπορείς να πατάς το Χ για ότι δε σου αρέσει ή τη καρδούλα(like) για ότι σου αρέσει.`
        },

        {
          q: 'Ακόμη δε μπορώ να καταλάβω πως θα ανταλλάξω όμως;',
          a:
            'Χιλιάδες χρήστες σαν κι εσένα κάνουν ακριβώς την ίδια διαδικασία. Μόλις κάποιος χρήστης που του έχεις κάνει like κάνει κι αυτός like στην αγγελία σου(έχει γίνει "match") μεταφέρεστε στο περιβάλλον του Chat ώστε να ξεκινήσετε τη συνομιλία και να ορίσετε τους όρους της συμφωνίας ανταλλαγής.'
        },

        {
          q: 'Μπορώ να δω ποιοι μου έχουν κάνει like;',
          a: `Υπάρχει η δυνατότητα να δεις ποιοι σου έχουν κάνει like αλλά και σε ποιους έχεις κάνει εσύ like ή έχετε κάνει "match" σύμφωνα με την αγγελία που έχεις εισέλθει στη πλατφόρμα από το <a target="_blank" href="${tradesUrl.value}">${tradesSiteName.value}${tradesUrl.value}</a>`
        },

        {
          q: 'Μπορώ να ενημερώνομαι για likes ή matches;',
          a: `Υπάρχει αυτόματο σύστημα το οποίο σε ενημερώνει όσο η αγγελία σου βρίσκεται διαθέσιμη στο <a target="_blank" href="${tradesUrl.value}">${tradesSiteName.value}${tradesUrl.value}</a>`
        }
      ]
      if (isCar.value) {
        faqsArray.push({
          q: 'Μπορώ να βρω τη λειτουργία εκτός από τον υπολογιστή και αλλού;',
          a:
            'Η συγκεκριμένη λειτουργία των ανταλλαγών είναι διαθέσιμη και σε <a rel="noreferrer" target="_blank" href="https://play.google.com/store/apps/details?id=com.car.gr">Android</a>  & <a rel="noreferrer" target="_blank" href="https://apps.apple.com/gr/app/car-gr/id1278899131">iOS</a> μέσω της εφαρμογής του Car.gr'
        })
      }
      return faqsArray
    })

    const steppers = computed(() => [
      {
        value: 'first',
        data: firstStepperData.value,
        title: 'Δεν έχεις αγγελία;'
      },
      {
        value: 'second',
        data: secondStepperData.value,
        title: 'Είσαι εγγεγραμμένος χρήστης και έχεις αγγελία;'
      }
    ])
    const onWindowResize = () => {
      setSteppersWidth()
    }

    const handleClickChevron = () => {
      scrollService.scrollTo(pg2Ref.value[0], {
        easing: 'ease-out',
        duration: 300,
        offset: -50
      })
    }

    return {
      icons,
      pg2Ref,
      firstStepperData,
      secondStepperData,
      firstStepper,
      firstStepperWidth,
      secondStepperWidth,
      steppersRef,
      steppers,
      isMobile,
      handleClickChevron,
      startDragging,
      stopDragging,
      mousemove,
      faqs,
      myClassifiedLink,
      newClassifiedLink,
      isCar,
      isPlot
    }
  },
  head() {
    const headService = this.$dep(HeadService)

    return headService.createHead({
      title: 'Νέος τρόπος για Ανταλλαγές (Μάθε πως)',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Θες να μάθεις τα πάντα για τις ανταλλαγές ή να ανταλλάξεις το ${
            this.isCar ? 'αυτοκίνητό' : 'ακίνητό'
          } σου με άλλο ${
            this.isCar ? 'αυτοκίνητο' : 'ακίνητο'
          }; Μάθε πως μπορείς να το ανταλλάξεις τώρα${
            this.isCar ? ', με τη νέα εφαρμογή του Car.gr' : ' στο Plot.gr'
          }`
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `Θες να μάθεις τα πάντα για τις ανταλλαγές ή να ανταλλάξεις το ${
            this.isCar ? 'αυτοκίνητό' : 'ακίνητό'
          } σου με άλλο ${
            this.isCar ? 'αυτοκίνητο' : 'ακίνητο'
          }; Μάθε πως μπορείς να το ανταλλάξεις τώρα${
            this.isCar ? ', με τη νέα εφαρμογή του Car.gr' : ' στο Plot.gr'
          }`
        },
        headService.createOgImageMetaItem(
          this.isCar
            ? '/nuxt-static/img/og/trades.png'
            : '/nuxt-static/img/og/plot-trades'
        )
      ]
    })
  }
})
